<!-- page-wrapper Start-->
<div [ngClass]="layout.config.settings.layout_type">
  <div class="page-wrapper" id="canvas-bookmark" [ngClass]="layoutClass">
    <app-header (hideShowSidebar)="hideShowSidebar($event)" [showSidebar]="showSidebar"></app-header>
    <!-- Page Body Start-->
    <div class="page-body-wrapper">
      <!-- [class.close_icon]="navServices.collapseSidebar" -->
      <div [ngClass]="{'d-none d-sm-block':!showSidebar,
        'd-block':showSidebar
      }" class="sidebar-wrapper" [attr.icon]="layout.config.settings.icon" >
        <app-sidebar (hideSidebar)="hideSidebar($event)" ></app-sidebar>
      </div>
      <div class="page-body">
        <main [@fadeInAnimation]="getRouterOutletState(o)">
          <router-outlet #o="outlet"></router-outlet>
        </main>
      </div>
      <!-- footer start-->
      <!-- <footer class="footer">
        <app-footer></app-footer>
      </footer> -->
      <!-- footer End-->
    </div>
    <!-- Page Body End-->
  </div>
</div>
<div class="bg-overlay1"></div>
<!-- page-wrapper End-->
